module.exports = __webpack_public_path__ + "img/partner8.f97378b1.png";